module.exports = __webpack_public_path__ + "img/KI-Pilot-Theorie-small.3472130f.png";